module.exports = __webpack_public_path__ + "img/nathalie_flower_field-mobile.27dd3994.webp";